export enum PayPalClickResult {
  PROCEED,
  REJECTED,
}
